export * from './IconSoundWave';
export { default as IconSoundWave } from './IconSoundWave';
